var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from "react";
import { BreadCrumb } from "@uigovpe/components";
import { Link, useLocation } from "react-router-dom";
import { COMPONENT_STRINGS } from "../../constants";
function prettifySegment(segment) {
    var decoded = decodeURIComponent(segment);
    var replaced = decoded.replace(/[-_]+/g, " ");
    if (/^[0-9]+$/.test(replaced))
        return COMPONENT_STRINGS.BREADCRUMB.DETAILS;
    return replaced
        .split(" ")
        .filter(Boolean)
        .map(function (s) { return s.charAt(0).toUpperCase() + s.slice(1); })
        .join(" ");
}
function isIdLikeSegment(segment) {
    if (!segment)
        return false;
    if (/^[0-9]+$/.test(segment))
        return true;
    if (/^[0-9a-fA-F]{8,64}$/.test(segment))
        return true;
    if (/^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(segment))
        return true;
    return false;
}
var BreadcrumbCustom = function (_a) {
    var _b = _a.labelMapping, labelMapping = _b === void 0 ? {} : _b, urlOverride = _a.urlOverride, _c = _a.hideIdLike, hideIdLike = _c === void 0 ? true : _c, _d = _a.hideSegments, hideSegments = _d === void 0 ? [] : _d, _e = _a.hideLastSegment, hideLastSegment = _e === void 0 ? false : _e, hidePredicate = _a.hidePredicate, manualItems = _a.manualItems, _f = _a.hideHome, hideHome = _f === void 0 ? false : _f;
    var location = useLocation();
    var pathname = location.pathname;
    var labelMappingStr = JSON.stringify(labelMapping);
    var hideSegmentsStr = JSON.stringify(hideSegments);
    var breadcrumbItems = useMemo(function () {
        var _a, _b;
        if (manualItems && manualItems.length > 0) {
            return manualItems.map(function (it, idx) {
                var isLast = idx === manualItems.length - 1;
                if (it.url && !isLast) {
                    return {
                        label: it.label,
                        template: (_jsx(Link, __assign({ to: it.url, className: "bc-link text-[#0034B7] hover:underline font-normal", style: { textDecoration: "none" } }, { children: it.label }))),
                    };
                }
                return {
                    label: it.label,
                    template: (_jsx("span", __assign({ className: "bc-current text-[#1A1A1A] font-normal" }, { children: it.label }))),
                };
            });
        }
        var asPath = pathname || "/";
        var cleaned = asPath.split("?")[0].split("#")[0];
        var originalSegments = cleaned === "/" ? [] : cleaned.split("/").filter(Boolean);
        var overrideBase = urlOverride
            ? urlOverride
                .replace(/^\/|\/$/g, "")
                .split("/")
                .filter(Boolean)[0] || null
            : null;
        var segments = __spreadArray([], originalSegments, true);
        var removedBase = null;
        if (overrideBase && segments[0] === overrideBase) {
            removedBase = segments.shift() || null;
        }
        var hideSet = new Set(hideSegments.map(function (s) { return s.toLowerCase(); }));
        var shouldHide = function (seg, idx, segs) {
            if (!seg)
                return true;
            if (hidePredicate && hidePredicate(seg, idx, segs))
                return true;
            if (hideSet.has(seg.toLowerCase()))
                return true;
            if (hideIdLike && isIdLikeSegment(seg))
                return true;
            if (hideLastSegment && idx === segs.length - 1)
                return true;
            return false;
        };
        var filtered = segments.filter(function (seg, idx) { return !shouldHide(seg, idx, segments); });
        var items = filtered.map(function (segment, idx) {
            var _a;
            var url = "/" + filtered.slice(0, idx + 1).join("/");
            var key = segment.toLowerCase();
            var label = (_a = labelMapping[key]) !== null && _a !== void 0 ? _a : prettifySegment(segment);
            var isLast = idx === filtered.length - 1;
            if (!isLast) {
                return {
                    label: label,
                    template: (_jsx(Link, __assign({ to: url, className: "text-[#0034B7] hover:underline font-normal" }, { children: label }))),
                };
            }
            return {
                label: label,
                template: (_jsx("span", __assign({ className: "bc-current text-[#1A1A1A] font-normal" }, { children: label }))),
            };
        });
        if (items.length === 0 && removedBase) {
            var key = removedBase.toLowerCase();
            var label = (_b = (_a = labelMapping[key]) !== null && _a !== void 0 ? _a : prettifySegment(removedBase)) !== null && _b !== void 0 ? _b : COMPONENT_STRINGS.BREADCRUMB.DETAILS;
            return [
                {
                    label: label,
                    template: (_jsx("span", __assign({ className: "bc-current text-[#1A1A1A] font-normal" }, { children: label }))),
                },
            ];
        }
        return items;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pathname,
        labelMappingStr,
        urlOverride,
        hideIdLike,
        hideSegmentsStr,
        hideLastSegment,
    ]);
    var homeItem = {
        url: "/",
        template: (_jsx(Link, __assign({ to: "/", className: "bc-home text-[#0034B7] hover:underline font-normal", style: { textDecoration: "none" } }, { children: COMPONENT_STRINGS.BREADCRUMB.HOME }))),
    };
    return (_jsx(BreadCrumb, { model: breadcrumbItems, home: hideHome ? undefined : homeItem }));
};
export { BreadcrumbCustom };
